import { SOV_IMPORT_HEADERS } from './sovImportConstants';

const getCell = (sheetRow, headerMapping, key) => {
  const header = headerMapping[key];
  if (!header) return undefined;
  return sheetRow[header];
};

/**
 * The request body for the import endpoint: one entry per non blank sheet row, holding the raw
 * cells exactly as the spreadsheet gave them. All parsing and validation happens on the backend,
 * which the preview reaches through the same endpoint with dryRun set.
 */
const toSovImportRequestRows = ({ sheetRows = [], headerMapping = {} }) => sheetRows
  .map((sheetRow, index) => {
    const cells = {};
    SOV_IMPORT_HEADERS.forEach(({ key }) => {
      const value = getCell(sheetRow, headerMapping, key);
      if (value !== undefined) cells[key] = value;
    });

    const isBlank = Object.values(cells).every((value) => (
      value === null || `${value}`.trim() === ''
    ));
    if (isBlank) return null;

    const { __rowNum__: sheetRowIndex } = sheetRow;
    return {
      // sheet_to_json counts rows from zero and attaches the index, and row one is the headers.
      rowNumber: Number.isFinite(sheetRowIndex) ? sheetRowIndex + 1 : index + 2,
      cells,
    };
  })
  .filter((row) => row !== null);

export default toSovImportRequestRows;
